module.exports = __webpack_public_path__ + "fe97c9429e0528987242eac0a407fabe.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_large_x1/public/picture/Chinese.jpg
// module id = 479
// module chunks = 0